module.exports = __webpack_public_path__ + "img/rank_icon_3.de7bf4f5.png";